export const DefaultRefetchIntervalForGenerating = 5000;
